module.exports = __webpack_public_path__ + "0f4c9e3.webp";